import * as PropTypes from 'prop-types';
import * as React from 'react';

import { IOfferHelper } from '../../../presenter';
import { IOffer } from '../../../types/offer';

import * as styles from './index.css';

export interface ILeasePeriodContext {
  offer: IOffer;
  offerHelper: IOfferHelper;
}

export class LeasePeriod extends React.Component {
  public context: ILeasePeriodContext;

  public static contextTypes = {
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
  };

  public render() {
    if (this.context.offer.dealType !== 'rent') {
      return null;
    }

    const offer = this.context.offerHelper;
    const leasePeriod = offer.presenters.getLeasePeriod();

    if (leasePeriod) {
      return (
        <div className={styles['lease-period']}>
          {`${leasePeriod.charAt(0).toUpperCase()}${leasePeriod.substring(1)}`}
        </div>
      );
    }

    return null;
  }
}
